<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" >
                  <div class="col p-0">
                    <div class="">
                      <MerchantMultiselect :multiple="true" v-model="merchantsFilter">
                      </MerchantMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <StoreMultiselect :multiple="true" v-model="storesFilter">
                      </StoreMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter">
                      </TrafficGroupMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="options"
                                   class="multiselect-sm"
                                   v-model="requestDTO.options"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_options')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="types"
                                   class="multiselect-sm"
                                   v-model="requestDTO.types"
                                   :options="Object.values(Direction)"
                                   :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.type')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currency"
                                   class="multiselect-sm multiselect-capitalize"
                                   v-model="requestDTO.currency"
                                   :options="store.getters['currencyMethods/currencies']"
                                   :custom-label="(opt) => opt"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.currency')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountFrom" class="form-control form-control-sm" :placeholder="helper.trans('labels.from_sum')" />
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountTo" class="form-control form-control-sm" :placeholder="helper.trans('labels.to_sum')" />
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <table class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="bg-light">
                <th class="text-capitalize-first">{{ helper.trans('labels.amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('deal_status.total') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('deal_status.processed') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('deal_status.rejected') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items">
                <td>{{ numberFormatter.formatNumber(item.amount) }}</td>
                <td>{{ numberFormatter.formatNumber(item.invoicesCount) }}</td>
                <td>{{ numberFormatter.formatNumber(item.dealsCount) }}</td>
                <td>{{numberFormatter.formatNumber(item.invoicesCount - item.dealsCount)}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import {UserRole} from "@/models/enum/UserRole";
import {DealStatus} from "@/models/enum/DealStatus";
import Multiselect from "vue-multiselect";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import UserDTO from "@/models/UserDTO";
import {DatePicker} from "v-calendar";
import moment from "moment";
import MerchantMultiselect from "@/components/MerchantMultiselect.vue";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import MerchantDTO from "@/models/MerchantDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import {Direction} from "@/models/enum/Direction";

const notification = useNotification()

export default defineComponent({
  components: {
    TrafficGroupMultiselect,
    StoreMultiselect,
    MerchantMultiselect,
    DatePicker,
    TeamLeadMultiselect,
    PayMethodIcon,
    TraderMultiselect,
    Multiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const defaultRequestDTO = {
      fromDate: moment().format('YYYY-MM-DD 00:00:00'),
      toDate: null,
      currency: 'RUB',
      types: [Direction.PAY_IN]
    };

    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      page: 1,
      items: [] as any,
      merchantsFilter: [] as MerchantDTO[],
      storesFilter: [] as MerchantStoreDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      requestDTO: {
        ...defaultRequestDTO
      } as any
    });



    const clearFilters = async () => {
      state.storesFilter = [];
      state.merchantsFilter = [];
      state.trafficGroupsFilter = [];
      state.requestDTO = {
        ...defaultRequestDTO
      }
    }

    const load = async () => {
      loader.value?.show()
      try {
        state.requestDTO.storeIds = state.storesFilter.map((value) => value.id)
        state.requestDTO.merchantIds = state.merchantsFilter.map((value) => value.id)
        state.requestDTO.trafficGroupsIds = state.trafficGroupsFilter.map((value) => value.id)

        state.items = await api.call.statistic.detailedAmounts({
            ...state.requestDTO,
            fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
            toDate: dateHelper.toUTC(state.requestDTO.toDate)
          });
      } finally {
        loader.value?.hide()
      }
    }

    const applyFilters = async () => {
      load()
    }


    onMounted(() => {
      load()
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      clearFilters,
      UserRole,
      DealStatus,
      applyFilters,
      store,
      Direction,
      load,
    }
  }
})
</script>
